// extracted by mini-css-extract-plugin
module.exports = {"flex":"Media_flex__2GfLG","item":"Media_item__2nprA"};